module.exports = __webpack_public_path__ + "static/media/pramodsenda.ceb6c769.jpeg";